var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c("div", { staticClass: "query-form-wrap" }, [
            _c(
              "div",
              { staticClass: "query-form-wrap-left" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      model: _vm.searchForm,
                      size: _vm.formSize,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "2.1333rem" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "请选择投屏方式",
                            },
                            model: {
                              value: _vm.searchForm.castFunType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "castFunType", $$v)
                              },
                              expression: "searchForm.castFunType",
                            },
                          },
                          _vm._l(_vm.useWrCloudSelect, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "请选择投屏内容",
                            },
                            model: {
                              value: _vm.searchForm.castCxtType,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "castCxtType", $$v)
                              },
                              expression: "searchForm.castCxtType",
                            },
                          },
                          _vm._l(_vm.castCxtTypeSelect, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "反诈标签",
                            },
                            model: {
                              value: _vm.searchForm.fraudLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "fraudLabel", $$v)
                              },
                              expression: "searchForm.fraudLabel",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "否", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "是", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "处理状态",
                            },
                            model: {
                              value: _vm.searchForm.handleState,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "handleState", $$v)
                              },
                              expression: "searchForm.handleState",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "正常", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "审核提醒", value: "1" },
                            }),
                            _c("el-option", {
                              key: "2",
                              attrs: { label: "审核阻断", value: "2" },
                            }),
                            _c("el-option", {
                              key: "3",
                              attrs: { label: "系统阻断", value: "3" },
                            }),
                            _c("el-option", {
                              key: "4",
                              attrs: { label: "忽略", value: "4" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "涉政标签",
                            },
                            model: {
                              value: _vm.searchForm.politicsLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "politicsLabel", $$v)
                              },
                              expression: "searchForm.politicsLabel",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "否", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "是", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "房间码" },
                          model: {
                            value: _vm.searchForm.roomCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "roomCode", $$v)
                            },
                            expression: "searchForm.roomCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "收端用户id" },
                          model: {
                            value: _vm.searchForm.receiverUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "receiverUserId", $$v)
                            },
                            expression: "searchForm.receiverUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "收端设备uid" },
                          model: {
                            value: _vm.searchForm.receiverUid,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "receiverUid", $$v)
                            },
                            expression: "searchForm.receiverUid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "发端设备uid" },
                          model: {
                            value: _vm.searchForm.senderUid,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "senderUid", $$v)
                            },
                            expression: "searchForm.senderUid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "发端用户id" },
                          model: {
                            value: _vm.searchForm.senderUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "senderUserId", $$v)
                            },
                            expression: "searchForm.senderUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "taskId" },
                          model: {
                            value: _vm.searchForm.taskId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "taskId", $$v)
                            },
                            expression: "searchForm.taskId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "涉恐标签",
                            },
                            model: {
                              value: _vm.searchForm.terrorLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "terrorLabel", $$v)
                              },
                              expression: "searchForm.terrorLabel",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "否", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "是", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "涉黄标签",
                            },
                            model: {
                              value: _vm.searchForm.yellowLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "yellowLabel", $$v)
                              },
                              expression: "searchForm.yellowLabel",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "否", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "是", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("el-cascader", {
                      attrs: {
                        size: "small",
                        placeholder: "城市选择",
                        options: _vm.cascaderOptions,
                        props: { value: "label", checkStrictly: true },
                      },
                      model: {
                        value: _vm.searchForm.receiverProvince,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "receiverProvince", $$v)
                        },
                        expression: "searchForm.receiverProvince",
                      },
                    }),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { "label-width": "2.1333rem" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "收端类型",
                            },
                            model: {
                              value: _vm.searchForm.receiverClientType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "receiverClientType",
                                  $$v
                                )
                              },
                              expression: "searchForm.receiverClientType",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "安卓", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "ios", value: "1" },
                            }),
                            _c("el-option", {
                              key: "2",
                              attrs: { label: "tv", value: "2" },
                            }),
                            _c("el-option", {
                              key: "3",
                              attrs: { label: "pc", value: "3" },
                            }),
                            _c("el-option", {
                              key: "4",
                              attrs: { label: "mac", value: "4" },
                            }),
                            _c("el-option", {
                              key: "5",
                              attrs: { label: "h5手机", value: "5" },
                            }),
                            _c("el-option", {
                              key: "6",
                              attrs: { label: "h5电脑", value: "6" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: _vm.small,
                              clearable: "",
                              placeholder: "区域",
                            },
                            model: {
                              value: _vm.searchForm.differentProvinceFlag,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "differentProvinceFlag",
                                  $$v
                                )
                              },
                              expression: "searchForm.differentProvinceFlag",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "正常", value: "0" },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "跨省", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": "记录创建开始日期",
                            "end-placeholder": "记录创建结束日期",
                            type: "daterange",
                            placeholder: "记录创建日期范围",
                          },
                          model: {
                            value: _vm.searchForm.startCreateTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "startCreateTime", $$v)
                            },
                            expression: "searchForm.startCreateTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKRESULT_SEARCH",
                                expression: "'SECURITY_RISKRESULT_SEARCH'",
                              },
                            ],
                            attrs: { icon: "el-icon-search", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleSearch()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                return _vm.handleClear()
                              },
                            },
                          },
                          [_vm._v("清空")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            [
              _c("avue-crud", {
                ref: "riskList",
                attrs: {
                  option: _vm.option,
                  data: _vm.list,
                  page: _vm.page,
                  "table-loading": _vm.loading,
                  search: _vm.search,
                },
                on: {
                  "update:page": function ($event) {
                    _vm.page = $event
                  },
                  "on-load": _vm.onLoad,
                  "selection-change": _vm.selectionChange,
                  "update:search": function ($event) {
                    _vm.search = $event
                  },
                  "row-cancel": function ($event) {
                    return _vm.handleCancel()
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange,
                  "search-change": _vm.onLoad,
                  "refresh-change": _vm.refresh,
                },
                scopedSlots: _vm._u([
                  {
                    key: "menu",
                    fn: function ({ type, size, row, index }) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKRESULT_VIEW",
                                expression: "'SECURITY_RISKRESULT_VIEW'",
                              },
                            ],
                            attrs: { size: size, type: type },
                            on: {
                              click: function ($event) {
                                return _vm.detail(row, index)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  row.handleState === "0" ||
                                  row.handleState === "1",
                                expression:
                                  "row.handleState === '0' || row.handleState === '1'",
                              },
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKRESULT_BLOCK",
                                expression: "'SECURITY_RISKRESULT_BLOCK'",
                              },
                            ],
                            attrs: { size: size, type: type },
                            on: {
                              click: function ($event) {
                                return _vm.handleStop(row.id)
                              },
                            },
                          },
                          [_vm._v("阻断")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  row.handleState === "0" ||
                                  row.handleState === "1",
                                expression:
                                  "row.handleState === '0' || row.handleState === '1'",
                              },
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "SECURITY_RISKRESULT_IGNORE",
                                expression: "'SECURITY_RISKRESULT_IGNORE'",
                              },
                            ],
                            attrs: { size: size, type: type },
                            on: {
                              click: function ($event) {
                                return _vm.handleIngore(row.id, index)
                              },
                            },
                          },
                          [_vm._v("忽略")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "originalUrl",
                    fn: function (scope) {
                      return [
                        scope.row.originalUrl
                          ? _c("el-button", {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:copy",
                                  value: scope.row.originalUrl,
                                  expression: "scope.row.originalUrl",
                                  arg: "copy",
                                },
                              ],
                              attrs: {
                                type: "text",
                                size: "small",
                                icon: "el-icon-document-copy",
                              },
                              on: { click: _vm.copyTip },
                            })
                          : _vm._e(),
                        _vm._v(" \n                    "),
                        _c("span", [_vm._v(_vm._s(scope.row.originalUrl))]),
                      ]
                    },
                  },
                  {
                    key: "remark",
                    fn: function (scope) {
                      return [
                        scope.row.remark
                          ? _c("el-button", {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:copy",
                                  value: scope.row.remark,
                                  expression: "scope.row.remark",
                                  arg: "copy",
                                },
                              ],
                              attrs: {
                                type: "text",
                                size: "small",
                                icon: "el-icon-document-copy",
                              },
                              on: { click: _vm.copyTip },
                            })
                          : _vm._e(),
                        _vm._v(" \n                    "),
                        _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "详情",
                "modal-append-to-body": false,
                visible: _vm.detailDialog,
                width: "90%",
                "before-close": _vm.closeDialog,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.detailDialog = $event
                },
              },
            },
            [
              _c("h3", [_vm._v("风控信息")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", overflow: "auto" },
                  attrs: { data: _vm.tableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "fraudLabel", label: "反诈标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.fraudLabel === "0"
                              ? _c("span", [_vm._v("否")])
                              : _c("span", [_vm._v("是")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "fraudRiskLevel", label: "反诈评分等级" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "fraudRiskScore", label: "反诈风控分数" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "politicsLabel", label: "涉政标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.politicsLabel === "0"
                              ? _c("span", [_vm._v("否")])
                              : _c("span", [_vm._v("是")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "politicsRiskLevel", label: "涉政评分等级" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "politicsRiskScore", label: "涉政风控分数" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "terrorLabel", label: "涉恐标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.terrorLabel === "0"
                              ? _c("span", [_vm._v("否")])
                              : _c("span", [_vm._v("是")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "terrorRiskLevel", label: "涉恐评分等级" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "terrorRiskScore", label: "涉恐风控分数" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "yellowLabel", label: "涉黄标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.yellowLabel === "0"
                              ? _c("span", [_vm._v("否")])
                              : _c("span", [_vm._v("是")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "yellowRiskLevel", label: "涉黄评分等级" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "yellowRiskScore", label: "涉黄风控分数" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "taskId", label: "TaskID" },
                  }),
                ],
                1
              ),
              _c("h3", [_vm._v("房间信息")]),
              _c("h4", [_vm._v("共有信息")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", overflow: "auto" },
                  attrs: { data: _vm.tableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "castFunType",
                      label: "投屏方式",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  { 1: "局域网", 2: "公网" }[
                                    +scope.row.castFunType
                                  ]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "castCxtType",
                      label: "投屏内容",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  {
                                    1: "镜像",
                                    2: "推送",
                                    3: "云桌面",
                                    4: "音频文件",
                                    5: "图片文件",
                                    6: "其他",
                                    7: "好友分享",
                                  }[+scope.row.castCxtType]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "handleState",
                      label: "处理状态",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  {
                                    0: "正常",
                                    1: "审核提醒",
                                    2: "审核阻断",
                                    3: "系统阻断",
                                    4: "忽略",
                                  }[+scope.row.handleState]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "senderBrand", label: "厂商", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  { 1: "网易", 2: "即构", 3: "腾讯" }[
                                    +scope.row.senderBrand
                                  ]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "uid", label: "UID", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "mirrorStartTime", label: "投屏开始时间" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "endTime", label: "投屏结束时间" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "roomCode", label: "房间码" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "uuid", label: "用户ID" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(scope.row.uuid)),
                            ]),
                            _vm._v(
                              "\n                           \n                        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "state", label: "投屏状态" },
                  }),
                ],
                1
              ),
              _c("h4", [_vm._v("收端信息")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", overflow: "auto" },
                  attrs: { data: _vm.tableUserDetail.receivers, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "appId", label: "收端appId" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "nation", label: "收端国籍" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "收端省份" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "收端城市" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "county", label: "收端县区" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "ip", label: "收端ip" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "clientType", label: "收端类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  {
                                    0: "安卓",
                                    1: "ios",
                                    2: "tv",
                                    3: "pc",
                                    4: "mac",
                                    5: "h5手机",
                                    6: "h5电脑",
                                  }[+scope.row.receiverClientType]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "uid", label: "收端设备uid" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userId", label: "收端用户id" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "wifiName", label: "收端wifi名称" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "收端名称" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userTag", label: "收端用户标签" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "deviceTag", label: "收端设备标签" },
                  }),
                ],
                1
              ),
              _c("h4", [_vm._v("发端信息")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", overflow: "auto" },
                  attrs: { data: _vm.tableUserDetail.senders, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "appId", label: "发端appId" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "nation", label: "发端国籍" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "province", label: "发端省份" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "发端城市" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "county", label: "发端县区" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "ip", label: "发端ip" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "uid", label: "发端设备uid" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userId", label: "发端用户id" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "clientType", label: "发端类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  {
                                    0: "安卓",
                                    1: "ios",
                                    2: "tv",
                                    3: "pc",
                                    4: "mac",
                                    5: "h5手机",
                                    6: "h5电脑",
                                  }[+scope.row.senderClientType]
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "userTag", label: "发端用户标签" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "deviceTag", label: "发端设备标签" },
                  }),
                ],
                1
              ),
              _c("h3", [_vm._v("风控记录")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.riskRecord, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "keywords", label: "关键词", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "label", label: "标签" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.label === "fraud"
                              ? _c("span", [_vm._v("涉诈")])
                              : scope.row.label === "yellow"
                              ? _c("span", [_vm._v("涉黄")])
                              : scope.row.label === "terror"
                              ? _c("span", [_vm._v("涉恐")])
                              : scope.row.label === "politics"
                              ? _c("span", [_vm._v("涉政")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "picUrl",
                      label: "命中图片url",
                      width: "300",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: scope.row.picUrl,
                                  target: "blank",
                                },
                              },
                              [
                                _c(
                                  "el-image",
                                  {
                                    attrs: {
                                      fit: "fit",
                                      src: scope.row.picUrl,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "placeholder" },
                                        slot: "placeholder",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    加载中"
                                        ),
                                        _c("span", { staticClass: "dot" }, [
                                          _vm._v("..."),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "riskResult", label: "风控结果" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "createTime", label: "创建时间" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "updateTime", label: "更新时间" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: {
                    padding: "10px 20px 20px",
                    "text-align": "right",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.detailData.current,
                      "page-sizes": [5, 10, 15, 30],
                      "page-size": _vm.detailData.size,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.detailData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
              _c("h3", [_vm._v("抓取图片记录")]),
              _c(
                "el-row",
                _vm._l(_vm.riskImages.resultData, function (item, index) {
                  return _c(
                    "el-col",
                    { key: item.id, attrs: { span: 2 } },
                    [
                      _c(
                        "el-card",
                        {
                          attrs: {
                            "body-style": {
                              padding: "0px",
                              "text-align": "center",
                            },
                            shadow: "hover",
                          },
                        },
                        [
                          _c("el-image", {
                            staticStyle: {
                              height: "120px",
                              "text-align": "center",
                              position: "relative",
                            },
                            attrs: {
                              src: item.requestJson,
                              fit: "fill",
                              "preview-src-list": _vm.rearrangedArray(index),
                            },
                          }),
                          _c("div", [
                            _c("time", { staticClass: "time" }, [
                              _vm._v(_vm._s(item.createTime)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: {
                    padding: "10px 20px 20px",
                    "text-align": "right",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.riskImages.queryData.current,
                      "page-sizes": [10, 20, 30, 40],
                      "page-size": _vm.riskImages.queryData.size,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.riskImages.queryData.total,
                    },
                    on: {
                      "size-change": _vm.handleImageSizeChange,
                      "current-change": _vm.handleImageCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }